"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", { value: true });
/** Perform an in-place bitwise XOR operation on two bytestrings */
function xor(a, b) {
    for (let i = 0; i < b.length; i++) {
        a[i] ^= b[i];
    }
}
exports.xor = xor;
